import React, { useState, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import { getAuth, verifyPasswordResetCode, confirmPasswordReset } from "firebase/auth";
import { Form, Card, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import LayoutOne from "../layouts/LayoutOne";
import Breadcrumb from "../wrappers/breadcrumb/Breadcrumb";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import MetaTags from "react-meta-tags";
import { multilanguage } from "redux-multilanguage";

const ResetPasswordPage = ({ location, strings }) => {
  const { pathname } = location;
  const auth = getAuth();
  const params = new URLSearchParams(window.location.search);
  const mode = params.get("mode");
  const oobCode = params.get("oobCode");

  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (mode === "resetPassword" && oobCode) {
      verifyPasswordResetCode(auth, oobCode)
        .then((email) => setEmail(email))
        .catch(() => setError(strings["reset_password_link_invalid"] || "連結已失效或錯誤"));
    }
  }, [auth, mode, oobCode, strings]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      setMessage(strings["reset_password_success"]);
    } catch {
      setError(strings["reset_password_fail"]);
    }
    setLoading(false);
  }

  const isEnglish = strings["language"] === "en";
  const metaTitle = isEnglish
    ? `${strings['reset_password']} | Wing Hang Care Products`
    : `${strings['reset_password']} | Wing Hang 關愛用品`;
  const metaDescription = isEnglish
    ? `Reset your Wing Hang Care Products account password securely.`
    : `安全地重設您的 Wing Hang 關愛用品帳戶密碼。`;

  return (
    <Fragment>
      <MetaTags>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
      </MetaTags>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>{strings["home"]}</BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>{strings["reset_password"]}</BreadcrumbsItem>
      <LayoutOne
        headerContainerClass="container-fluid"
        headerPaddingClass="header-padding-2"
        headerTop="visible"
      >
        <Breadcrumb />
        <div className="login-register-area pt-100 pb-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-12 ml-auto mr-auto">
                <div className="login-register-wrapper">
                  <div className="login-register-form">
                    <Card>
                      <Card.Body>
                        <h2 className="text-center mb-4">{strings["reset_password"]}</h2>
                        {error && <Alert variant="danger">{error}</Alert>}
                        {message && <Alert variant="success">{message}</Alert>}
                        {email && <p className="text-center">{strings["account"]}: {email}</p>}
                        <Form onSubmit={handleSubmit}>
                          <Form.Group id="newPassword">
                            <Form.Label>{strings["new_password"]}</Form.Label>
                            <Form.Control
                              type="password"
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                              required
                              autoFocus
                            />
                          </Form.Group>
                          <div className="login-button mt-3">
                            <button disabled={loading} className="w-100" type="submit">
                              {strings["confirm_reset"]}{" "}
                              {loading && <i className="fa fa-spinner fa-pulse"></i>}
                            </button>
                          </div>
                        </Form>
                        <div className="w-100 text-center mt-3">
                          <Link to="/login">{strings["login"]}</Link>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

ResetPasswordPage.propTypes = {
  location: PropTypes.object,
  strings: PropTypes.object
};

export default multilanguage(ResetPasswordPage);
